import React from 'react';
import { Availability } from '@/types/library';

interface AvailabilityPillProps {
  status?: Availability;
}

const AvailabilityPill: React.FC<AvailabilityPillProps> = ({ status = 'unknown' }) => {
  const getStyles = () => {
    switch (status) {
      case 'available':
        return 'bg-green-100 text-green-800 border-green-300';
      case 'loaned':
        return 'bg-amber-100 text-amber-800 border-amber-300';
      case 'reference':
        return 'bg-blue-100 text-blue-800 border-blue-300';
      default:
        return 'bg-gray-100 text-gray-800 border-gray-300';
    }
  };

  const getLabel = () => {
    switch (status) {
      case 'available':
        return 'Available';
      case 'loaned':
        return 'On Loan';
      case 'reference':
        return 'Reference Only';
      default:
        return 'Status Unknown';
    }
  };

  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${getStyles()}`}
      aria-label={`Book status: ${getLabel()}`}
    >
      {getLabel()}
    </span>
  );
};

export default AvailabilityPill;
